import { TimePicker } from '@material-ui/pickers'
import React from 'react'
import { Field } from 'react-final-form'

interface Props {
    name: string
    helperText?: React.ReactNode
    label?: string | React.ReactNode
    margin?: 'dense' | 'normal' | 'none'
    minutesStep?: number
    required?: boolean
}

const TimeField: React.FC<Props> = ({
    name,
    helperText,
    label,
    minutesStep,
    margin = 'normal',
    required,
}) => {
    return (
        <Field name={name}>
            {({ input: { onChange, value }, meta }) => {
                const showError =
                    ((meta.submitError && !meta.dirtySinceLastSubmit) || meta.error) && meta.touched
                return (
                    <TimePicker
                        helperText={helperText}
                        required={required}
                        margin={margin}
                        error={showError}
                        label={label}
                        value={value}
                        onChange={onChange}
                        minutesStep={minutesStep}
                        fullWidth
                    />
                )
            }}
        </Field>
    )
}

export default TimeField
